"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[244],{

/***/ 2370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ DynamicBlocks; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(97212);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.5_zwnwwcpulpacxjlmvctaxclnzi/node_modules/next/dynamic.js
var dynamic = __webpack_require__(31506);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_iydcyk4gah44gajk2m3r5bwf3i/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(89992);
;// CONCATENATED MODULE: ./src/dynamic-blocks/dynamic-blocks.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const Noop = _ref => {
  let {
    children
  } = _ref;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: children
  });
};

const blocks = {
  M010HeroModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 149).then(__webpack_require__.bind(__webpack_require__, 69149)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(69149)]
    }
  }),
  M020CategoriesModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 148).then(__webpack_require__.bind(__webpack_require__, 57148)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(57148)]
    }
  }),
  M021ReferencedCategoriesModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 930).then(__webpack_require__.bind(__webpack_require__, 36930)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(36930)]
    }
  }),
  M060UspModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 539).then(__webpack_require__.bind(__webpack_require__, 32539)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(32539)]
    }
  }),
  M070MediaModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 814).then(__webpack_require__.bind(__webpack_require__, 36814)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(36814)]
    }
  }),
  M075MediaAndTextModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 63).then(__webpack_require__.bind(__webpack_require__, 63063)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(63063)]
    }
  }),
  M080ContentCarrousel: dynamic_default()(() => __webpack_require__.e(/* import() */ 849).then(__webpack_require__.bind(__webpack_require__, 63849)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(63849)]
    }
  }),
  M085ProductCarousel: dynamic_default()(() => __webpack_require__.e(/* import() */ 214).then(__webpack_require__.bind(__webpack_require__, 96102)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(96102)]
    }
  }),
  M090QuoteModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 864).then(__webpack_require__.bind(__webpack_require__, 27864)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(27864)]
    }
  }),
  M100RichTextModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 102).then(__webpack_require__.bind(__webpack_require__, 5102)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(5102)]
    }
  }),
  M120AccordionModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 419).then(__webpack_require__.bind(__webpack_require__, 39419)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(39419)]
    }
  }),
  M140ProductListModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 781).then(__webpack_require__.bind(__webpack_require__, 81781)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(81781)]
    }
  }),
  M141ProductListModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 781).then(__webpack_require__.bind(__webpack_require__, 81781)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(81781)]
    }
  }),
  M130ProductDetailModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 318).then(__webpack_require__.bind(__webpack_require__, 32318)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(32318)]
    }
  }),
  M170SearchResultsModule: dynamic_default()(() => __webpack_require__.e(/* import() */ 842).then(__webpack_require__.bind(__webpack_require__, 82842)), {
    ssr: false,
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(82842)]
    }
  }),
  M171VehicleSearch: dynamic_default()(() => __webpack_require__.e(/* import() */ 786).then(__webpack_require__.bind(__webpack_require__, 3786)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(3786)]
    }
  }),
  M150BasketModule: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(333), __webpack_require__.e(135)]).then(__webpack_require__.bind(__webpack_require__, 56608)), {
    ssr: false,
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(56608)]
    }
  }),
  M160CheckoutModule: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(333), __webpack_require__.e(285)]).then(__webpack_require__.bind(__webpack_require__, 2450)), {
    ssr: false,
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(2450)]
    }
  }),
  M190ReceiptModule: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(333), __webpack_require__.e(696)]).then(__webpack_require__.bind(__webpack_require__, 97969)), {
    ssr: false,
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(97969)]
    }
  }),
  M200CancelOrder: dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(333), __webpack_require__.e(676)]).then(__webpack_require__.bind(__webpack_require__, 48940)), {
    loadableGenerated: {
      webpack: () => [/*require.resolve*/(48940)]
    }
  })
};

const DynamicBlock = _ref2 => {
  let {
    element
  } = _ref2;
  const Block = blocks[element.type] || Noop;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Block, _objectSpread({}, element));
};

const DynamicBlocks = _ref3 => {
  let {
    elements
  } = _ref3;

  if (!(elements !== null && elements !== void 0 && elements.length)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: elements === null || elements === void 0 ? void 0 : elements.map((element, index) => {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicBlock, {
        element: element
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./src/dynamic-blocks/index.ts


/***/ }),

/***/ 17244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ModulePage; }
});

// EXTERNAL MODULE: ./src/dynamic-blocks/index.ts + 1 modules
var dynamic_blocks = __webpack_require__(2370);
// EXTERNAL MODULE: ./src/services/cms/index.ts + 3 modules
var cms = __webpack_require__(94272);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.1.5_iydcyk4gah44gajk2m3r5bwf3i/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(89992);
;// CONCATENATED MODULE: ./src/page-type/page-types/module/ModulePage.tsx



function ModulePage() {
  const {
    data: page
  } = (0,cms/* usePage */.qt)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dynamic_blocks/* DynamicBlocks */.n, {
    elements: page === null || page === void 0 ? void 0 : page.pageElements
  });
}
;// CONCATENATED MODULE: ./src/page-type/page-types/module/index.ts


/***/ })

}]);